import { useEffect, useState } from "react";
import { colors } from "../../constants/theme";
import { filterItems } from "../../utils/search";
import type { Item } from "../../types";
import { timeAgo } from "../../utils/timeAgo";

function assert(name: string, cond: boolean) { return { name, ok: !!cond }; }

function runTests() {
  const results: { name: string; ok: boolean }[] = [];
  // 1. filterItems should not throw with empty query
  const items: Item[] = [{ id: "1", filename: "a.jpg", status: "Pending", meta: { title: "A" } }];
  results.push(assert("filterItems empty query returns same", filterItems(items, { field: undefined, query: "" }).length === 1));
  // 2. token search name: foo
  results.push(assert("token field search works", filterItems(items, { field: undefined, query: "name: a.jpg" }).length === 1));
  // 3. table data normalization
  const rows = Array.isArray(undefined as any) ? (undefined as any) : [];
  results.push(assert("normalize undefined -> []", Array.isArray(rows) && rows.length === 0));
  // 4. db title fallback to Untitled
  const t = ({ meta: { title: "" } } as Item).meta?.title?.trim() || "Untitled";
  results.push(assert("db 'Untitled' fallback", t === "Untitled"));
  // 5. timeAgo returns string
  results.push(assert("timeAgo string", typeof timeAgo(Date.now() - 3000) === "string"));
  // 6. deviceId present in free-form search set
  results.push(assert("deviceId included in free-form concat", filterItems([{ id: "2", deviceId: "ios-15pro-01" }], { field: undefined, query: "ios-15pro" }).length === 1));
  // 7. agent activity close transits to Completed/Error correctly (logic check without timers)
  const ag = { id: "act-x", agentId: "ai-style", agentName: "StyleClassifier-v3", agentKind: "AI" as const, startedAt: Date.now() - 1000, status: "Processing" as const };
  const closed = { ...ag, status: "Completed" as const, endedAt: Date.now() };
  results.push(assert("agent activity can close", closed.status === "Completed" && typeof closed.endedAt === "number"));

  return results;
}

export function TestPanel() {
  const [results, setResults] = useState<{ name: string; ok: boolean }[]>([]);
  useEffect(() => setResults(runTests()), []);
  const pass = results.filter((r) => r.ok).length;
  return (
    <div style={{ marginTop: 8, fontSize: 12, color: colors.text }}>
      <div style={{ fontWeight: 700 }}>Tests: {pass}/{results.length} passing</div>
      <ul style={{ margin: 0, paddingLeft: 16 }}>
        {results.map((r, i) => (
          <li key={i} style={{ color: r.ok ? "#2e7d32" : "#c62828" }}>{r.ok ? "✔" : "✖"} {r.name}</li>
        ))}
      </ul>
    </div>
  );
}

